import { useTranslation } from "react-i18next";

import { Checkbox, TableHeadCell } from "@digital-services/ui";

import { ApplicationJsonModel } from "@applications/models/ApplicationJsonModel";

import { useUserContext } from "@hooks/useUserContext";
import { SortDirection } from "@utils/sortUtil";

interface Props {
  application: ApplicationJsonModel;
  activeSort: string;
  sortDirection: SortDirection;
  handleSort: (val: string) => void;
  checkedAll: boolean;
  toggleSelectAll: () => void;
}

export const ApplicationUsersHeaderRow = (props: Props) => {
  const {
    application,
    activeSort,
    sortDirection,
    handleSort,
    checkedAll,
    toggleSelectAll
  } = props;

  const { user: currentUser } = useUserContext();

  const { t: tUser } = useTranslation(undefined, { keyPrefix: "user" });
  const { t: tCommon } = useTranslation();

  return (
    <tr className="leading-[0px]" data-testid="thead">
      {currentUser.isAdministrator && (
        <TableHeadCell>
          <Checkbox
            id={`checkAllApplicationUsers-${application.id}`}
            data-testid={`checkAllApplicationUsers-${application.id}`}
            variant="alternative"
            checked={checkedAll}
            label={""} // It is IMPORTANT to have label value as empty string, otherwise <Checkbox> disabled and checked properties are NOT used then
            onChange={toggleSelectAll}
          />
        </TableHeadCell>
      )}
      <TableHeadCell
        sortActive={activeSort === "name"}
        sortDirection={sortDirection}
        onSort={() => handleSort("name")}
      >
        <div data-testid="name-column">
          {tUser("display-name.column-header")}
        </div>
      </TableHeadCell>
      <TableHeadCell
        sortActive={activeSort === "email"}
        sortDirection={sortDirection}
        onSort={() => handleSort("email")}
      >
        <div data-testid="email-column">{tUser("email.column-header")}</div>
      </TableHeadCell>
      <TableHeadCell
        sortActive={activeSort === "role"}
        sortDirection={sortDirection}
        onSort={() => handleSort("role")}
      >
        <div data-testid="role-column">{tUser("role.column-header")}</div>
      </TableHeadCell>
      <TableHeadCell
        sortActive={activeSort === "status"}
        sortDirection={sortDirection}
        onSort={() => handleSort("status")}
      >
        <div data-testid="status-column">{tUser("status.column-header")}</div>
      </TableHeadCell>

      <TableHeadCell>
        {" "}
        <div data-testid="actions-column">
          {tCommon("actions.column-header")}
        </div>
      </TableHeadCell>
    </tr>
  );
};
